


export type CustomTypeTransmitState = 'Pending' | 'Transmitted' | 'Failed' | 'ShouldNotBeTransmitted';

export const CustomTypeTransmitState = {
    Pending: 'Pending' as CustomTypeTransmitState,
    Transmitted: 'Transmitted' as CustomTypeTransmitState,
    Failed: 'Failed' as CustomTypeTransmitState,
    ShouldNotBeTransmitted: 'ShouldNotBeTransmitted' as CustomTypeTransmitState
};

